import { FinanceDateType, DealStatus, PaymentType } from '@trnsact/trnsact-shared-types';
import { SelectOption } from '../../../global';
import { FinanceDateRange, FinanceDealStatus, FinancePaymentType } from '../pipelineAndWon/types';

export enum FinanceFilterType {
  DEAL_DATE = 'DEAL_DATE',
  SALES_REP = 'SALES_REP',
  LOCATION = 'LOCATION',
  PAYMENT_TYPE = 'PAYMENT_TYPE',
  DEAL_STATUS = 'DEAL_STATUS',
  DATE_TYPE = 'DATE_TYPE',
}

export type FinanceFilters = {
  [FinanceFilterType.DEAL_DATE]: FinanceDateRange;
  [FinanceFilterType.SALES_REP]: SelectOption[];
  [FinanceFilterType.LOCATION]: SelectOption[];
  [FinanceFilterType.PAYMENT_TYPE]: FinancePaymentType;
  [FinanceFilterType.DEAL_STATUS]: FinanceDealStatus;
  [FinanceFilterType.DATE_TYPE]: FinanceDateType;
};

export interface FinanceFilterCardProps {
  meta?: Partial<Record<FinanceFilterType, SelectOption[]>>;
}

export type FinanceFiltersPayload = {
  date?: {
    range: { from: string; to: string };
    by: FinanceDateType;
  };
  salesRep?: (string | null)[];
  location?: (string | null)[];
  paymentType?: PaymentType;
  dealStatus?: DealStatus;
};
